import { useEffect, useState } from "react";
import { Button } from "react-bulma-components";
import Icon from '@mdi/react';

import { mdiArrowUpBoldOutline  } from '@mdi/js';

const MINIMUM_HEIGHT = 2800;

// Component used for scrolling to top when scrolled
// To certain heights in this case 2800
const ScrollToTop = () => {
    const [scroll, setScroll] = useState(false);

    // Function to return boolean if scroll height is at certain level
    const handleScrollTop = e => {
        const window = e.currentTarget;

        if (window.scrollY > MINIMUM_HEIGHT) {
            setScroll(true);
        } else {
            setScroll(false);
        }

    };

    // UseEffect to for ComponentDidUpdate 
    // Listen for scroll events and call function above
    useEffect(() => {
        window.addEventListener("scroll", e => handleScrollTop(e));

        return () => {
            window.removeEventListener("scroll", e => handleScrollTop(e));
        }
    }, []);

    return (
        <>
            { //display this element if boolean returned true
                (scroll) ? (
                    <Button rounded px={4} size="large" onClick={() => {
                        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                      }} outlined style={{ position: "fixed", bottom: "25px", right: "30px" }} color="black">
                            <Icon size={1} path={mdiArrowUpBoldOutline}/>
                    </Button>
                ) : ""
            }
        </>
    )
};

export default ScrollToTop;